import { Badge } from "@themes/pollinator/ui/Badge";
import { SchedulingTimeSlotDurationIcon, SchedulingCheckmarkIcon } from "../SchedulingTimeSlotDurationIcon";
import Type from "@themes/pollinator/ui/Type";

export type Props = {
  duration?: number;
  /** Show a checkmark instead of duration (for options mode) */
  showCheckmark?: boolean;
};

export function SchedulingAvailabilityTimeSlotBadge({ duration, showCheckmark }: Props) {
  // Show checkmark badge for options mode
  if (showCheckmark) {
    return (
      <div className="absolute top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2 z-20">
        <Badge className="flex items-center justify-center bg-brand-50 px-1.5">
          <span className="text-brand-600">
            <SchedulingCheckmarkIcon />
          </span>
        </Badge>
      </div>
    );
  }

  // Show duration badge for freeform mode
  if (!duration) {
    return null;
  }

  return (
    <div className="absolute top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2 z-20">
      <Badge
        className={`w-18 flex items-center justify-start gap-1 bg-brand-50`}
      >
        <SchedulingTimeSlotDurationIcon duration={duration} />

        <Type variant="caption" className="flex-1 text-center pr-2">
          {`${duration.toFixed(1).replace(/\.0$/, "")} hr`}
        </Type>
      </Badge>
    </div>
  );
}

export default SchedulingAvailabilityTimeSlotBadge;

